import { Flex, Icon, PARTIALS, Text, Toggle } from "@proda-ai/ui-kit";
import styled from "styled-components";

const SyledNewExperienceWrapper = styled(Flex)`
    background-color: ${PARTIALS.COLORS["proda-lavender-10"]};
    border: 1px solid ${PARTIALS.COLORS["proda-lavender"]};
    border-radius: 4px;
    z-index: 4;
    height: 28px;
`;

const StyledHeaderWrapper = styled(Flex)`
    height: 60px;
    background-color: #f8f8f8;
    border-bottom: 1px solid #0a0a0a;
    z-index: 1001;
    padding-left: 5px;
    padding-right: 5px;
`;

interface NewExperienceSectionProps {
    newUiEnabled: boolean;
    handleNewUiToggle: (checked: boolean) => void;
}

const NewExperienceSection = ({
    newUiEnabled,
    handleNewUiToggle,
}: NewExperienceSectionProps): JSX.Element => {
    const bannerText = newUiEnabled
        ? "You are now trying the new PRODA experience"
        : "A simpler PRODA experience is available";
    const toggleText = newUiEnabled
        ? "Switch to the old experience"
        : "Try it out";

    return (
        <StyledHeaderWrapper justifyContent="space-between" alignItems="center">
            <Flex justifyContent="space-between" flex="1" alignItems="center">
                <SyledNewExperienceWrapper
                    alignItems="center "
                    flexGrow={1}
                    flexGap="small"
                    mx={2}
                    p={1}
                    justifyContent="space-between"
                >
                    <Flex alignItems="center" flexGap="small">
                        <Icon
                            icon="megaphone"
                            color={PARTIALS.COLORS["proda-black-10"]}
                        ></Icon>
                        <Text ml={1}>{bannerText}</Text>
                    </Flex>
                </SyledNewExperienceWrapper>
                <Flex alignItems="center" flexGap="small" mx={2}>
                    <Text>{toggleText}</Text>
                    <Toggle
                        data-track-id={`new-ui-toggle-${newUiEnabled ? "off" : "on"}`}
                        checked={newUiEnabled}
                        onChange={() => handleNewUiToggle(!newUiEnabled)}
                    />
                </Flex>
            </Flex>
        </StyledHeaderWrapper>
    );
};

export default NewExperienceSection;
